import React from "react";
import { useTranslation } from "react-i18next";
import { Identifiable, Project as P } from "@planzone/dto";
import { useZoneProjectsRetrieval } from "@planzone/view-models";
import { zoneProjectsRetrievalFilter } from "@planzone/dto";

import { Checkbox } from "@common/checkbox";
import { Props } from "./types";
import { Project } from "./project";
import styles from "./styles.scss";

function ProjectsList(props: Props) {
  const defaultFilter = {
    ...zoneProjectsRetrievalFilter,
    limit: 999,
    isSortedByJoinedProject: true,
    isOpen: true,
    isSortedAlphabetically: true,
  };
  const { t } = useTranslation();
  const { projects, canRetrieveNextProjects, retrieveZoneProjects } =
    useZoneProjectsRetrieval(props.zone, defaultFilter);
  const isProjectSelected = (project: Identifiable<P>) =>
    !!props.selectedProjects.find(({ uuid }) => project.uuid === uuid);

  React.useEffect(() => {
    canRetrieveNextProjects &&
      retrieveZoneProjects({
        zone: props.zone,
        filter: defaultFilter,
      });
  }, [canRetrieveNextProjects]);

  return (
    <div className={styles.projectsList}>
      <div className={styles.heading}>
        <label
          className={styles.label}
          onClick={() =>
            projects.every(isProjectSelected)
              ? props.selectProjects([])
              : props.selectProjects(projects)
          }
        >
          <Checkbox isChecked={projects.every(isProjectSelected)} />
          <span>{t("projectsTransfer.projects.selectAll")}</span>
        </label>
      </div>
      <ul className={styles.list}>
        {projects.map((project) => (
          <li key={project.uuid} className={styles.item}>
            <Project
              project={project}
              isProjectSelected={isProjectSelected(project)}
              selectProject={(project) =>
                props.selectProjects([...props.selectedProjects, project])
              }
              unSelectProject={(project) =>
                props.selectProjects(
                  props.selectedProjects.filter(
                    ({ uuid }) => uuid !== project.uuid,
                  ),
                )
              }
            />
          </li>
        ))}
      </ul>
    </div>
  );
}
export { ProjectsList };
